import { colorPalette } from "@iewc/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { getRelatedProductsCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

type Props = OwnProps & WidgetProps & HasProduct;

export interface ProductDetailsCmiProductWidgetStyles {
    wrapper?: InjectableCss;
    list?: InjectableCss;
}

export const cmiProductWidgetStyles: ProductDetailsCmiProductWidgetStyles = {
    wrapper: {
        css: css`
            background-color: ${colorPalette.common?.background};
            padding: 15px;
        `,
    },
    list: {
        css: css`
            font-size: 14px;
            display: inline-flex;
            flex-direction: column;
            margin-left: 15px;
            list-style: disc outside none;
        `,
    },
};

const styles = cmiProductWidgetStyles;

const ProductDetailsCmiProducts: React.FC<Props> = ({ product, fields }) => {
    const [items, setItems] = React.useState<any[]>([]);

    const fetchCmiProducts = async () => {
        const res = await getRelatedProductsCollectionV2({
            productId: product.id,
            relationship: "CMIRelatedProducts",
            pageSize: 1000,
        });
        setItems(res?.products || []);
    };

    React.useEffect(() => {
        if (product.id) {
            fetchCmiProducts();
        }
    }, [product.id]);

    return items.length ? (
        <StyledWrapper {...styles.wrapper}>
            {fields.title && (
                <Typography variant="h5" as="h3">
                    {fields.title}
                </Typography>
            )}
            <StyledWrapper as="ul" {...styles.list}>
                {items.map(item => (
                    <li key={item.id}>
                        <Link href={item.canonicalUrl}>{item.detail.modelNumber}</Link>
                    </li>
                ))}
            </StyledWrapper>
        </StyledWrapper>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCmiProducts),
    definition: {
        displayName: "CMI Products",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.title,
                editorTemplate: "TextField",
                displayName: "Title",
                defaultValue: "",
                tab: {
                    displayName: "Basic",
                    sortOrder: 0,
                },
            },
        ],
    },
};

export default widgetModule;
